<template>
  <div class="config-property">
    <div>Tipo de login utilizado:</div>
    <label class="input-radio" v-for="(tipo, idx) in tipos" :key="idx">
      <div class="row">
        <div class="col-sm-1 mr-3">
          <input
            type="radio"
            :value="tipo.value"
            name="TIPO_LOGIN_PORTAL"
            v-model="value.TIPO_LOGIN_PORTAL"
          />
        </div>
        <div class="col-sm-11">
          {{ tipo.label }} <br />
          <img :src="tipo.img" />
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import IMG_LOGIN_MODERNO from "../img/LOGIN_MODERNO.png";
import IMG_LOGIN_CLASSICO_PORTAL from "../img/LOGIN_CLASSICO_PORTAL.png";

export default {
  name: "TIPO_LOGIN_PORTAL",
  props: ["value"],
  data() {
    return {
      tipos: [
        {
          label: "Login moderno | Destaque imagem",
          value: "LOGIN_MODERNO",
          img: IMG_LOGIN_MODERNO,
        },
        {
          label: "Login clássico | Centralizado",
          value: "LOGIN_CLASSICO_PORTAL",
          img: IMG_LOGIN_CLASSICO_PORTAL,
        },
      ],
    };
  },
};
</script>
